import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Subsector } from '../../../interfaces/subsector.interface';
import { SubsectorService } from "../../../services/subsector";
import { ReactiveFormsModule, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { CustomerAddressService } from '../../../services/customeraddress';
import { CustomerAddress } from '../../../interfaces/customeraddress.interface';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-edit-customeraddress',
  imports: [ReactiveFormsModule, DatePipe],
  templateUrl: './edit-customeraddress.html',
  styleUrl: './edit-customeraddress.css'
})
export class EditCustomerAddressComponent implements OnInit {

    subsectors: Subsector[] = [];
    submitted: boolean = false;
    loading: boolean = false;
    myForm: FormGroup;
    selectedCustomerAddress: CustomerAddress = {} as CustomerAddress;

  constructor (private subsectorService: SubsectorService, 
                private cdr: ChangeDetectorRef,
                private router: Router,
                private customerAddressService: CustomerAddressService,
              private fb: FormBuilder) {
                  this.myForm = this.fb.group({
                id: new FormControl(''),
                customercode: new FormControl(''),
                addressserial: new FormControl(''),
                subsectorcode: new FormControl('',[Validators.required]),
                salesareacode: new FormControl(''),
                accountcode: new FormControl(''),
                ordercode: new FormControl(''),
                addressline1: new FormControl(''), 
                addressline2: new FormControl(''),
                addresszip: new FormControl(''),
                uploadSelected: new FormControl(true),
                uploaded: new FormControl('0000-00-00')
                }); //}, { updateOn: 'submit' });
              }

async updateCustomerAddress(): Promise<void>
{
          var id = this.myForm.value.id != null ? this.myForm.value.id.trim() : "";     
          var customercode = this.myForm.value.customercode != null ? this.myForm.value.customercode.trim() : "";       
        var addressserial = this.myForm.value.addressserial != null ? this.myForm.value.addressserial.trim() : "";
        var salesareacode = this.myForm.value.salesareacode != null ? this.myForm.value.salesareacode.trim() : "";
        var subsectorcode = this.myForm.value.subsectorcode != null ? this.myForm.value.subsectorcode.trim() : "";
        var accountcode = this.myForm.value.accountcode != null ? this.myForm.value.accountcode.trim() : "";
        var ordercode = this.myForm.value.ordercode != null ? this.myForm.value.ordercode.trim() : "";
        var addressline1 = this.myForm.value.addressline1 != null ? this.myForm.value.addressline1.trim() : "";
        var addressline2 = this.myForm.value.addressline2 != null ? this.myForm.value.addressline2.trim() : "";
        var addresszip = this.myForm.value.addresszip != null ? this.myForm.value.addresszip.trim() : "";
        var uploaded = this.myForm.value.uploaded != null ? this.myForm.value.uploaded.trim() : "0000-00-00";
        var uploadSelected = this.myForm.value.uploadSelected;

      if (uploadSelected)
      {
        uploaded = "0000-00-00";
      }
      
      try
        {
          await this.customerAddressService.updateCustomerAddress(customercode,addressserial,salesareacode,subsectorcode,customercode,ordercode,addressline1,addressline2,addresszip,uploaded,id)
          this.cdr.detectChanges();
          this.router.navigateByUrl('customeraddress'); 
        } catch (error) {
          console.error('updatecustomer',error);
        }
}
async ngOnInit(): Promise<void>
{    
  if (typeof this.customerAddressService.editcustomeraddress === undefined || this.customerAddressService.editcustomeraddress.id === undefined)
        {
          this.router.navigateByUrl('customeraddress'); ;
          return;
        }
     try 
      {
        this.subsectors = await this.subsectorService.getSubsector();
        this.cdr.detectChanges();
      } catch (error) {
        console.error('getsubsector',error);
      }
      this.selectedCustomerAddress = this.customerAddressService.editcustomeraddress;
      //this.myForm.value.customercode = this.customerService.selectedCustomer.customercode;
      this.myForm.get('id')?.setValue(this.selectedCustomerAddress.id);
      this.myForm.get('customercode')?.setValue(this.selectedCustomerAddress.customercode);
      this.myForm.get('addressserial')?.setValue(this.selectedCustomerAddress.addressserial);
      this.myForm.get('subsectorcode')?.setValue(this.selectedCustomerAddress.subsectorcode);
      this.myForm.get('salesareacode')?.setValue(this.selectedCustomerAddress.salesareacode);
      this.myForm.get('accountcode')?.setValue(this.selectedCustomerAddress.accountcode);
      this.myForm.get('ordercode')?.setValue(this.selectedCustomerAddress.ordercode);
      this.myForm.get('addressline1')?.setValue(this.selectedCustomerAddress.addressline1);
      this.myForm.get('addressline2')?.setValue(this.selectedCustomerAddress.addressline2);
      this.myForm.get('addresszip')?.setValue(this.selectedCustomerAddress.addresszip);
      this.myForm.get('uploaded')?.setValue(this.selectedCustomerAddress.uploaded);
    
       this.cdr.detectChanges();
}

get id() {
    return this.myForm.get('id');
  }
get customercode() {
    return this.myForm.get('customercode');
  }
  get subsectorcode() {
    return this.myForm.get('subsectorcode');
  }
  get salesareacode() {
    return this.myForm.get('salesareacode');
  }
  get ordercode() {
    return this.myForm.get('ordercode');
  }
  get addressline1() {
    return this.myForm.get('addressline1');
  }
  get addressline2() {
    return this.myForm.get('addressline2');
  }
  get addresszip() {
    return this.myForm.get('addresszip');
  }
  get uploaded() {
    return this.myForm.get('uploaded');
  }
  
goBack(): void {
    //this.location.back();
    this.router.navigateByUrl('customeraddress');
  }
}
